export const createAction = (type, payload: any = {}) => ({
  type,
  payload,
});
